import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13c305a2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=13c305a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c305a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13c305a2')) {
      api.createRecord('13c305a2', component.options)
    } else {
      api.reload('13c305a2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=13c305a2&scoped=true&", function () {
      api.rerender('13c305a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allocation_configs/index.vue"
export default component.exports